import * as React from 'react';
import { Table, SortableTableHeader } from "soprasteria-ui-library";
import { IGeneralDentalReferral } from '../../../models/IGeneralDentalReferral';
import { Link } from 'react-router-dom';
import { PATIENT, GENERAL_DENTAL_REFERRAL } from '../../../utils/RouteConstants';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { formatPersonalSecurityNumberAndOrganisationNumber } from '../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper';

interface IGeneralDentalReferralSearchTable {
    generalDentalReferrals: IGeneralDentalReferral[];
    hasRoleOrtodontist: boolean;
    hasRoleAllmäntandvård: boolean;
    hasRoleSysAdmin: boolean;
}

export const GeneralDentalReferralSearchTable: React.FunctionComponent<IGeneralDentalReferralSearchTable> = ({ generalDentalReferrals, hasRoleOrtodontist, hasRoleAllmäntandvård, hasRoleSysAdmin }) => {

    const renderTableLink = (generalDentalReferral: IGeneralDentalReferral, linkText?: string) => {
        return <Link to={`${PATIENT}/${generalDentalReferral.patientGuidId}/${GENERAL_DENTAL_REFERRAL}/${generalDentalReferral.generalDentalReferralId}`}>{linkText}</Link>
    }

    const numberOfColumns = () => {
        return hasRoleSysAdmin ? 6 : (hasRoleOrtodontist || hasRoleAllmäntandvård) ? 5 : 4;
    }

    return (
        <Table hoverableRows>
            <thead>
                <tr>
                    <SortableTableHeader propertyToSortBy="SentDate" headerText="Datum skickad" />
                    <SortableTableHeader propertyToSortBy="GeneralDentalReferralNumber" headerText="Remiss-ID" />
                    <SortableTableHeader propertyToSortBy="Patient.PersonalSecurityId" headerText="Personnummer" />
                    {hasRoleAllmäntandvård || hasRoleSysAdmin ?
                        <th>Remittent</th>
                        : null
                    }
                    {hasRoleOrtodontist || hasRoleSysAdmin ?
                        <th>Remissmottagare</th>
                        : null
                    }
                    <SortableTableHeader propertyToSortBy="GeneralDentalReferralStatus.Description" headerText="Status" />
                </tr>
            </thead>
            <tbody>
                {
                    generalDentalReferrals.length > 0 ?
                        generalDentalReferrals.map((generalDentalReferral, key) =>
                            <tr key={key} className="clickable-row">
                                <td className="table-data-link">{renderTableLink(generalDentalReferral, dateTimeToDateString(generalDentalReferral.sentDate))}</td>
                                <td className="table-data-link">{renderTableLink(generalDentalReferral, generalDentalReferral.generalDentalReferralNumber?.toString())}</td>
                                <td className="table-data-link">{renderTableLink(generalDentalReferral, formatPersonalSecurityNumberAndOrganisationNumber(generalDentalReferral.patientPersonalSecurityId))}</td>
                                {hasRoleAllmäntandvård || hasRoleSysAdmin ?
                                    <td className="table-data-link">{renderTableLink(generalDentalReferral, generalDentalReferral.referrerCareProvider?.name)}</td>
                                    : null
                                }
                                {hasRoleOrtodontist || hasRoleSysAdmin ?
                                    <td className="table-data-link">{renderTableLink(generalDentalReferral, generalDentalReferral.recipientCareProvider?.name)}</td>
                                    : null
                                }
                                <td className="table-data-link">{renderTableLink(generalDentalReferral, generalDentalReferral.generalDentalReferralStatus)}</td>
                            </tr>
                        )
                        : <tr><td colSpan={numberOfColumns()}>Hittade inga allmäntandvårdsremisser</td></tr>
                }
            </tbody>
        </Table>
    )
}